import { render } from "./BudgetTab.vue?vue&type=template&id=7ec7bca7&scoped=true&ts=true"
import script from "./BudgetTab.ts?vue&type=script&lang=ts"
export * from "./BudgetTab.ts?vue&type=script&lang=ts"

import "./BudgetTab.scss?vue&type=style&index=0&id=7ec7bca7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec7bca7"]])

export default __exports__